import { Button, Select, Input }             from 'antd';
import React, { useState, useEffect } from 'react';
import "./landingPage.scss";
import {
  useNavigate
}                                     from 'react-router-dom';
import HomeImage                      from "../../assets/homes/home.jpeg";
import {
  ReactComponent as Two
}                                     from '../../assets/icons/Icon-1.svg';
import {
  ReactComponent as One
}                                     from '../../assets/icons/Icon.svg';
import {
  ReactComponent as Three
}                                     from '../../assets/icons/Vector.svg';
import heroImage                      from "../../assets/landingPage/homeImg.png";
import ContainerCard                  from '../../reuseableComponents/CardComponent/ContainerCard/ContainerCard';
import HeadingNDescription            from '../../reuseableComponents/headingNDescription/headingNDescription';
import Loader                         from '../../reuseableComponents/Loader/Loader';
import Notification                   from '../../reuseableComponents/Notification';
import {
  getRecommendedPropertiesApi,
  getFeaturedPropertiesApi,
  getAll,
  getRecentViewedPropertiesApi
}                         from './apis/apis';
import { SearchOutlined } from '@ant-design/icons';

const LandingPage = () => {
  const [state, setState] = useState({
    recommendedProperties: [],
    featuredProperties: [],
    loaderRecommendation: true,
    loaderFeature: true,
    searchInput: 'Distrito Nacional',
    getProperties: false,
    recentViewed: [],
    recentViewedLoader: false
  })

  const navigate = useNavigate()

  let number = [
    {
      title: "Sold",
      value: "2.6K+"
    },
    {
      title: "Rent Out",
      value: "51K+"
    },
    {
      title: "For Sale",
      value: "65K+"
    },
    {
      title: "For Rent",
      value: "41K+"
    }
  ]

  let isLoggedIn = localStorage.getItem("token") && localStorage.getItem("userLogin");
  const fetchProperties = async (type) => {
    setState((prevState) => ({
      ...prevState,
      [type === "recommended" ? "loaderRecommendation" : "loaderFeature"]: true,
    }));

    try {
      let result =
        type === "recommended"
          ? (isLoggedIn ? await getAll({
            longitude: 0,
            latitude: 0
          }) : await getRecommendedPropertiesApi())
          : await getFeaturedPropertiesApi();

      if (result?.data?.success) {
        setState((prevState) => ({
          ...prevState,
          [type === "recommended"
            ? "recommendedProperties"
            : "featuredProperties"]: result.data.data,
          [type === "recommended"
            ? "loaderRecommendation"
            : "loaderFeature"]: false,
        }));
      }
      type === "recommended" && await fetchRecentView()

    }
    catch (err) {
      setState((prevState) => ({
        ...prevState,
        [type === "recommended" ? "loaderRecommendation" : "loaderFeature"]: false,
      }));
    }
  };

  const fetchRecentView = async () => {
    setState(prevState => ({...prevState, recentViewedLoader:true}))
    try {
      const response = await getRecentViewedPropertiesApi()
      if (response.data.data) {
        setState(prevState => ({
          ...prevState,
          recentViewed: response.data.data,
          recentViewedLoader: false
        }))
      }
      else {
        setState({
          ...state,
          recentViewedLoader: false
        })
      }
    }
    catch (e) {
      setState({
        ...state,
        recentViewedLoader: false
      })
    }
  }

  const fetchData = async () => {
    await Promise.all([fetchProperties("recommended"), fetchProperties("featured")]);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = () => {
    navigate("/searchProperty", {
      state: { searchQuery: state.searchInput },
    });
  };

  const locations = [
    { label: "Distrito Nacional", value: "Distrito Nacional" },
    { label: "Santo Domingo Este", value: "Santo Domingo Este" },
    { label: "Santo Domingo Norte", value: "Santo Domingo Norte" },
    { label: "Santo Domingo Oeste", value: "Santo Domingo Oeste" },
    { label: "Santiago", value: "Santiago" },
    { label: "Punta Cana", value: "Punta Cana" },
    { label: "San Cristóbal", value: "San Cristóbal" },
    { label: "La Vega", value: "La Vega" },
    { label: "Puerto Plata", value: "Puerto Plata" },
    { label: "San Pedro de Macorís", value: "San Pedro de Macorís" },
    { label: "Azua", value: "Azua" },
    { label: "Bahoruco", value: "Bahoruco" },
    { label: "Barahona", value: "Barahona" },
    { label: "Dajabón", value: "Dajabón" },
    { label: "Duarte", value: "Duarte" },
    { label: "El Seibo", value: "El Seibo" },
    { label: "Elías Piña", value: "Elías Piña" },
    { label: "Espaillat", value: "Espaillat" },
    { label: "Hato Mayor", value: "Hato Mayor" },
    { label: "Hermanas Mirabal", value: "Hermanas Mirabal" },
    { label: "Independencia", value: "Independencia" },
    { label: "La Altagracia", value: "La Altagracia" },
    { label: "La Romana", value: "La Romana" },
    { label: "María Trinidad Sánchez", value: "María Trinidad Sánchez" },
    { label: "Monseñor Nouel", value: "Monseñor Nouel" },
    { label: "Monte Plata", value: "Monte Plata" },
    { label: "Montecristi", value: "Montecristi" },
    { label: "Pedernales", value: "Pedernales" },
    { label: "Peravia", value: "Peravia" },
    { label: "Samaná", value: "Samaná" },
    { label: "San José de Ocoa", value: "San José de Ocoa" },
    { label: "San Juan", value: "San Juan" },
    { label: "Sánchez Ramírez", value: "Sánchez Ramírez" },
    { label: "Santiago Rodríguez", value: "Santiago Rodríguez" },
    { label: "Valverde", value: "Valverde" }
  ];


  return <div className={ "landingPageContainer" }>

    <div className={ "heroSection" }>
      <img src={ heroImage } alt="hero-image" className={ "heroImage" }/>
      <div className={ "left-container" }>
        <h1>Easy Way to find a Perfect Property</h1>
        <p className={ "description" }>Rentay makes finding your ideal property simple and quick. With easy search
          filters for location, price, size, and amenities,
          you can browse a wide range of listings, view detailed information, and even take virtual tours. Our platform
          allows you to compare properties, save your
          favorites, and contact owners or agents—all from the comfort of your home.</p>
        <div style={ {
          marginTop: 40
        } }>
          {/*<Select*/}
          {/*  defaultValue="Distrito Nacional"*/}
          {/*  size={ "large" }*/}
          {/*  style={ { marginTop: 0 } }*/}
          {/*  options={ locations }*/}
          {/*  onChange={ (e) => setState({*/}
          {/*    ...state,*/}
          {/*    searchInput: e*/}
          {/*  }) }*/}
          {/*/>*/}
          <Input
           prefix={ <SearchOutlined style={ { color: "grey" } }/> }
           size="large"
           placeholder="Enter location"
           onChange={(e)=> setState({...state, searchInput: e.target.value})}
          />
          <Button disabled={ state.searchInput === '' } onClick={ handleSearch } size="large" type="primary">
            Search
          </Button>
        </div>
        <Button onClick={ () => navigate("/allHomes") } className={ "findProBtn" } size="large" type="primary">
          Let’s Find Your Property
        </Button>
        <div className={ "numberData" }>
          {
            number.map(item => <div>
              <h2>{ item.value }</h2>
              <p>{ item.title }</p>
            </div>)
          }
        </div>
      </div>
    </div>

    {
      isLoggedIn &&
      <div style={{
        padding:100
      }}>
        <HeadingNDescription
          heading={ "Recently Viewed" }
          description={ "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s," }
        />
        {
          state.recentViewedLoader ? <Loader/> : state.recentViewed.length > 0 && <div style={ {
          marginTop: 50
        } }>
          <ContainerCard cardType={"recentViewed"} getProperties={ () => fetchRecentView() } data={ state.recentViewed }/>
        </div>
        }
      </div>
    }

    <div className={ "all-container" }>
      <HeadingNDescription
        heading={ "Homes For You" }
        description={ "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s," }
      />
      <div className={ "myHomes" }>
        <div className={ "container" }>
          <img className={ "img-container" } src={ HomeImage } alt=""/>
          <img className={ "img-container" } src={ HomeImage } alt=""/>
          <img className={ "img-container" } src={ HomeImage } alt=""/>
        </div>
        <div className={ "container" } style={ {
          direction: "rtl"
        } }>
          <img className={ "img-container" } src={ HomeImage } alt=""/>
          <img className={ "img-container" } src={ HomeImage } alt=""/>
          <img className={ "img-container" } src={ HomeImage } alt=""/>
        </div>
      </div>

      <div className={ "blueContainer" }>
        <div>
          <Three/>
          <h1>Buy</h1>
          <p>
            Discover your ideal spot with an immersive photo experience and access to the most listings, featuring
            unique options you won't find anywhere else.
          </p>
        </div>

        <div>
          <Two/>
          <h1>Rent</h1>
          <p>
            We're building a seamless online experience—from browsing the largest rental network to applying and paying
            rent.
          </p>
        </div>

        <div>
          <One/>
          <h1>Sell</h1>
          <p>
            Whatever path you choose to sell your home, we're here to guide you toward a successful sale.
          </p>
        </div>
      </div>

      <HeadingNDescription
        heading={ "Featured" }
        description={ "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s," }
      />
      { state.loaderFeature ? <Loader/> : <div style={ {
        marginTop: 50
      } }>
        <ContainerCard getProperties={ () => () => fetchData() } data={ state.featuredProperties }/>
      </div> }

      <HeadingNDescription
        heading={ "Our Recommendations" }
        description={ "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s," }
      />
      { state.loaderRecommendation ? <Loader/> : <div style={ {
        marginTop: 50
      } }>
        <ContainerCard getProperties={ () => fetchData() } data={ state.recommendedProperties }/>
      </div> }
    </div>
  </div>
}

export default LandingPage